const SET_ORDER_SORT_FILTER = "SET_ORDER_SORT_FILTER";
const CLEAR_ORDER_SORT_FILTER = "CLEAR_ORDER_SORT_FILTER";

const OrderSortFilter = {
  SET_ORDER_SORT_FILTER,
  CLEAR_ORDER_SORT_FILTER
};

export default OrderSortFilter;
